import type { Loop, Scene } from './types'

export interface VelocitySnapshot {
  sceneId: string
  velocity: number
  acceleration: number
  uniqueCreators: number
  forkCompletions: number
  videoReplies: number
  contributions: number
  windowMinutes: 15
}

export function calculateSceneVelocity(scene: Scene, loops: Loop[]): VelocitySnapshot {
  const entries = loops.filter((loop) => loop.sceneId === scene.id || scene.loopIds.includes(loop.id))
  const uniqueCreators = new Set(entries.map((loop) => loop.creatorId)).size
  const forkCompletions = entries.reduce((sum, loop) => sum + loop.forks, 0)
  const videoReplies = entries.reduce((sum, loop) => sum + loop.replies, 0)
  const contributions = entries.length
  const creationPressure = uniqueCreators * 14 + forkCompletions * 5 + videoReplies * 3 + contributions * 8
  const previousWindow = Math.max(1, Math.round(scene.participants * .008))
  const currentWindow = uniqueCreators + Math.round(forkCompletions * .4) + Math.round(videoReplies * .25)
  const acceleration = Math.round(((currentWindow - previousWindow) / previousWindow) * 100)
  const velocity = Math.max(1, Math.min(99, Math.round(18 + Math.log2(creationPressure + 1) * 8)))
  return { sceneId: scene.id, velocity, acceleration, uniqueCreators, forkCompletions, videoReplies, contributions, windowMinutes: 15 }
}

export function sceneVelocityFeed(scenes: Scene[], loops: Loop[]): Array<{ scene: Scene; snapshot: VelocitySnapshot }> {
  return scenes.map((scene) => ({ scene, snapshot: calculateSceneVelocity(scene, loops) })).sort((left, right) => right.snapshot.velocity - left.snapshot.velocity || right.snapshot.acceleration - left.snapshot.acceleration)
}
